import { DeleteOutlined, MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Flex, Tooltip, Typography } from 'antd';
import { type CartItem, useCart } from '../../cart-store';
import { useCanAfford } from '../../hooks';
import { formatPoints } from '../../utils';
import styles from './CartItemRow.module.scss';

const { Text } = Typography;

type Props = {
  item: CartItem;
};

export const CartItemRow = ({ item }: Props) => {
  const setCount = useCart((s) => s.setCount);
  const remove = useCart((s) => s.remove);
  const { affordable } = useCanAfford(item.price);

  const atStock = item.count >= item.stock;
  const increment = (
    <Button
      size="small"
      icon={<PlusOutlined />}
      disabled={atStock || !affordable}
      onClick={() => setCount(item.skuId, item.count + 1)}
    />
  );

  return (
    <Flex className={styles.row} align="center" gap={12}>
      <div className={styles.thumb}>
        {item.imageUrl ? <img src={item.imageUrl} alt={item.title} /> : <span>No image</span>}
      </div>
      <Flex vertical flex={1} gap={4} className={styles.info}>
        <Text strong ellipsis={{ tooltip: item.title }}>
          {item.title}
        </Text>
        <Text type="secondary">{formatPoints(item.price)}</Text>
        <Flex align="center" gap={8}>
          <Button
            size="small"
            icon={<MinusOutlined />}
            disabled={item.count <= 1}
            onClick={() => setCount(item.skuId, item.count - 1)}
          />
          <Text className={styles.count}>{item.count}</Text>
          {!atStock && !affordable ? (
            <Tooltip title="Not enough points">
              <span style={{ display: 'inline-flex', cursor: 'not-allowed' }}>{increment}</span>
            </Tooltip>
          ) : (
            increment
          )}
          <Button size="small" type="text" danger icon={<DeleteOutlined />} onClick={() => remove(item.skuId)} />
        </Flex>
      </Flex>
      <Text strong className={styles.lineTotal}>
        {formatPoints(item.price * item.count)}
      </Text>
    </Flex>
  );
};
